import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'
import '../Workflow.scss'
import {shallowEqual} from 'react-redux'
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import { TaskStatus } from '../../../services/TaskStatus';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import HrbTranslate from '../../../../../components/language/HrbTranslate';
import Lang from '../../../../../components/language/services/Lang';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import LoadingTextValue from '../../../../../components/library/layout/LoadingTextValue';
import ViewDownloadDocument from '../../../../../components/library/documents/ViewDownloadDocument';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import { AdditionalDocuments } from '../../../services/AdditionalDocuments';
import { useTicketState } from '../../hooks/useTicketStateHook';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import DateTime from '../../../../../components/library/common/DateTime';
import EmdashText from '../../../../../components/library/common/EmdashText';

const ReviewReturnTask = (props) => {
    const ticketIsOpen = useTicketState(props.ticket);
    const [baseTaskList, setBaseTaskList] = useState([WorkflowTasks.RETURN_REVIEWED])
    const [additionalTaskList, setAdditionalTaskList] = useState([]);
    const [effectiveStatus, setEffectiveStatus] = useState(TaskStatus.NOT_STARTED)
    const [returnType, , province, primaryName, spouseName] = useInterviewInfo(props.ticket);

    const [primaryDocs, setPrimaryDocs] = useState([]);
    const [spouseDocs, setSpouseDocs] = useState([]);

    const [errorList, setErrorList] = useState([]);

    // let's get the task completions for both the return reviewed and the return prepared tasks
    const [status, completions] = useTaskStatus(props.ticket, baseTaskList);
    const [prepareStatus, prepareCompletions] = useTaskStatus(props.ticket, [WorkflowTasks.RETURN_PREPARED])

    const [additionalStatus, additionalCompletions] = useTaskStatus(props.ticket, additionalTaskList, status)

    useEffect(() => {
        if (province === 'QC') {
            setBaseTaskList([WorkflowTasks.RETURN_REVIEWED, WorkflowTasks.RETURN_REVIEWED_RQ])
        }
    }, [province])

    useEffect(() => {
        var prepComp = (prepareCompletions || []).filter(c => c.status !== TaskStatus.INVALID)
        var pc = prepComp.length > 0 ? prepComp[0] : {}

        if (pc && pc.completionData) {
            var cd = JSON.parse(pc.completionData);
            var addlDocs = (cd ? cd.additionalDocuments : null) || {}
            var additionalTaskIds = Object.keys(addlDocs).map(k => k)
                .filter(l => !l.startsWith('T1_') && !l.startsWith('T183_') && !l.startsWith('TP1_') && !l.startsWith('TP1000'));
            if (!shallowEqual(additionalTaskList, additionalTaskIds)) {
                setAdditionalTaskList(additionalTaskIds);
                var p = additionalTaskIds.filter(y => y.endsWith('_P'))
                var s = additionalTaskIds.filter(y => y.endsWith('_S'))
                p.sort(documentSort)
                s.sort(documentSort)
                setPrimaryDocs(p)
                setSpouseDocs(s)
            }
        } else {
            setPrimaryDocs([])
            setSpouseDocs([])
        }
    }, [prepareCompletions, status, prepareStatus]);

    const documentSort = (a, b) => {
        return AdditionalDocuments.indexOf(a) - AdditionalDocuments.indexOf(b)
    }

    useEffect(() => {
        // if there are no additional docs, treat the add status as complete
        var addStatus = primaryDocs.length === 0 && spouseDocs.length === 0 && additionalStatus === TaskStatus.NOT_STARTED
            ? TaskStatus.COMPLETE : additionalStatus

        if (errorList.length > 0) {
            setEffectiveStatus(TaskStatus.ERROR)
        } else if (prepareStatus === TaskStatus.COMPLETE && status === TaskStatus.COMPLETE && addStatus === TaskStatus.COMPLETE) {
            setEffectiveStatus(TaskStatus.COMPLETE)
        } else if (prepareStatus === TaskStatus.COMPLETE) {
            // this should be in progess as long as the prepare task status is complete
            setEffectiveStatus(TaskStatus.IN_PROGRESS)
        } else {
            setEffectiveStatus(TaskStatus.NOT_STARTED)
        }
    }, [status, additionalStatus, prepareStatus, errorList.length])

    const getT183SignDate = (filer) => {
        var completion, data, cs;

        cs = completions.filter(c => c.status !== TaskStatus.INVALID && c.workflowTaskId === WorkflowTasks.RETURN_REVIEWED)
        completion = cs.length > 0 ? cs[0] : null;

        if (completion && completion.completionData) {
            data = JSON.parse(completion.completionData);
            if (filer === 'PRIMARY') {
                return (data || {}).primaryApprovalDate;
            } else {
                return (data || {}).spouseApprovalDate;
            }
        }
    }

    const getFileId = (taskId) => {
        var completion, data, cs;
        if (taskId === 'T183_P' || taskId === 'T183_S') {
            cs = completions.filter(c => c.status !== TaskStatus.INVALID && c.workflowTaskId === WorkflowTasks.RETURN_REVIEWED)
            completion = cs.length > 0 ? cs[0] : null;
            if (completion && completion.completionData) {
                data = JSON.parse(completion.completionData);
                if (taskId === 'T183_P') {
                    return (data || {}).primaryApprovalFileId;
                } else {
                    return (data || {}).spouseApprovalFileId;
                }
            }
        } else if (taskId === 'TP1000TE_P' || taskId === 'TP1000TE_S') {
            cs = completions.filter(c => c.status !== TaskStatus.INVALID && c.workflowTaskId === WorkflowTasks.RETURN_REVIEWED_RQ)
            completion = cs.length > 0 ? cs[0] : null;
            if (completion && completion.completionData) {
                data = JSON.parse(completion.completionData);
                if (taskId === 'TP1000TE_P') {
                    return (data || {}).primaryApprovalFileId;
                } else {
                    return (data || {}).spouseApprovalFileId;
                }
            }
        } else {
            cs = (additionalCompletions || []).filter(c => c.status !== TaskStatus.INVALID && c.workflowTaskId === taskId)
            completion = cs.length > 0 ? cs[0] : null;
            if (completion && completion.completionData) {
                data = JSON.parse(completion.completionData);
                return (data || {}).fileId
            }
        }
    }

    const handleViewDownloadFail = (docType) => {
        if (!errorList.includes(docType)) {
            setErrorList([...errorList, docType])
        }
    }

    const renderAdditionalDocRow = () => {
        let items = [];
        let maxIndex = Math.max(primaryDocs.length, spouseDocs.length)
        for (var i = 0; i < maxIndex; ++i) {
            items.push(
                <div className='columns approvals' key={`addl_doc_row_${i}`}>
                    <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                        {primaryDocs[i] &&
                            <ViewDownloadDocument documentType={primaryDocs[i]} ticketId={props.ticket.id}
                                disabled={!Boolean(getFileId(primaryDocs[i]))}
                                onViewDownloadFail={handleViewDownloadFail} />
                        }
                        {primaryDocs[i] && errorList.includes(primaryDocs[i]) &&
                            <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                        }

                    </div>
                    {returnType === 'coupled' &&
                        <div className='column is-5'>
                            {spouseDocs[i] &&
                                <ViewDownloadDocument documentType={spouseDocs[i]} ticketId={props.ticket.id}
                                    disabled={!Boolean(getFileId(spouseDocs[i]))}
                                    onViewDownloadFail={handleViewDownloadFail} />
                            }
                            {spouseDocs[i] && errorList.includes(spouseDocs[i]) &&
                                <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                            }
                        </div>
                    }
                </div>
            )
        }
        return items;
    }

    const createLink = (urlKey, titleKey) => (
        <a href={Lang.getCurrentValue(urlKey)}>
            <HrbTranslate text={titleKey} />
        </a>
    )

    return (
        <WorkflowTask status={effectiveStatus} taskId={WorkflowTasks.RETURN_REVIEWED}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/ClientApprovals.htm'
                    descriptions={['ApprovalsTask.Description']}
                />
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <h4><LoadingTextValue value={primaryName} /></h4>
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <h4><LoadingTextValue value={spouseName} /></h4>
                    </div>
                }
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <HrbTranslate text="ApprovalsTask.DocSignature" className='p1' />
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <HrbTranslate text="ApprovalsTask.DocSignature" className='p1' />
                    </div>
                }
            </div>
            <div className='columns approvals'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <ViewDownloadDocument documentType='T183_P' ticketId={props.ticket.id}
                        disabled={!Boolean(getFileId('T183_P'))}
                        onViewDownloadFail={handleViewDownloadFail} />
                    {errorList.includes('T183_P') &&
                        <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                    }
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <ViewDownloadDocument documentType='T183_S' ticketId={props.ticket.id}
                            disabled={!Boolean(getFileId('T183_S'))}
                            onViewDownloadFail={handleViewDownloadFail} />
                        {errorList.includes('T183_S') &&
                            <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                        }
                    </div>
                }
            </div>
            {province === 'QC' &&
                <div className='columns approvals'>
                    <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                        <ViewDownloadDocument documentType='TP1000TE_P' ticketId={props.ticket.id}
                            disabled={!Boolean(getFileId('TP1000TE_P'))}
                            onViewDownloadFail={handleViewDownloadFail} />
                        {errorList.includes('TP1000TE_P') &&
                            <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                        }
                    </div>
                    {returnType === 'coupled' &&
                        <div className='column is-5'>
                            <ViewDownloadDocument documentType='TP1000TE_S' ticketId={props.ticket.id}
                                disabled={!Boolean(getFileId('TP1000TE_S'))}
                                onViewDownloadFail={handleViewDownloadFail} />
                            {errorList.includes('TP1000TE_S') &&
                                <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                            }
                        </div>
                    }
                </div>
            }
            {renderAdditionalDocRow()}
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <HrbTranslate text="ApprovalsTask.DocReview" className='p1' />
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <HrbTranslate text="ApprovalsTask.DocReview" className='p1' />
                    </div>
                }
            </div>
            <div className='columns approvals'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <ViewDownloadDocument documentType='T1_P' ticketId={props.ticket.id} disabled={effectiveStatus === TaskStatus.NOT_STARTED} onViewDownloadFail={handleViewDownloadFail} />
                    {errorList.includes('T1_P') &&
                        <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                    }
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <ViewDownloadDocument documentType='T1_S' ticketId={props.ticket.id} disabled={effectiveStatus === TaskStatus.NOT_STARTED} onViewDownloadFail={handleViewDownloadFail} />
                        {errorList.includes('T1_S') &&
                            <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                        }
                    </div>
                }
            </div>
            {province === 'QC' &&
                <div className='columns approvals'>
                    <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                        <ViewDownloadDocument documentType='TP1_P' ticketId={props.ticket.id} disabled={effectiveStatus === TaskStatus.NOT_STARTED} onViewDownloadFail={handleViewDownloadFail} />
                        {errorList.includes('TP1_P') &&
                            <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                        }
                    </div>
                    {returnType === 'coupled' &&
                        <div className='column is-5'>
                            <ViewDownloadDocument documentType='TP1_S' ticketId={props.ticket.id} disabled={effectiveStatus === TaskStatus.NOT_STARTED} onViewDownloadFail={handleViewDownloadFail} />
                            {errorList.includes('TP1_S') &&
                                <TaskErrorText errorKey='ApprovalsTask.ErrorMissingDoc' />
                            }
                        </div>
                    }
                </div>
            }
            <div className='columns'>
                <div className='column is-10 is-offset-1 prep-border small-margins' />
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                    <VerticalNameChildren
                        textKey="ApprovalsTask.T183SignedOn"
                        loading={!props.ticket}>
                        <p className='p1 medium-weight'>
                            <DateTime dateAndTime includeSeconds value={getT183SignDate('PRIMARY')} fallbackValue={<EmdashText />} />
                        </p>
                    </VerticalNameChildren>
                </div>
                {returnType === 'coupled' &&
                    <div className='column is-5'>
                        <VerticalNameChildren
                            textKey="ApprovalsTask.T183SignedOn"
                            loading={!props.ticket}>
                            <p className='p1 medium-weight'>
                            <DateTime dateAndTime includeSeconds value={getT183SignDate('SPOUSE')} fallbackValue={<EmdashText />} />
                            </p>
                        </VerticalNameChildren>
                    </div>
                }
            </div>
            {effectiveStatus === TaskStatus.COMPLETE && ticketIsOpen &&
                <div className='columns prep-section'>
                    <div className='column is-offset-1 is-8'>
                        <p className='p2'>
                            <HrbTranslate text='ApprovalsTask.Reset'
                                params={{
                                    PrepReturn: createLink('PaymentTask.PrepareReturnLink', 'PaymentTask.PrepareReturnLinkText')
                                }}
                            />
                        </p>
                    </div>
                </div>
            }
        </WorkflowTask>
    );
}

ReviewReturnTask.whyDidYouRender = false;

ReviewReturnTask.propTypes = {
    ticket: PropTypes.object
}

export default ReviewReturnTask